import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faScaleBalanced } from '@fortawesome/free-solid-svg-icons';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import api from '../../api/api';
import { useTranslation } from 'react-i18next';
import './rules.scss';

export function Rules() {
    const { t, i18n } = useTranslation();
    const [rules, setRules] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchRules = async () => {
            setLoading(true);
            try {
                // Map i18n language codes to our supported languages
                let langCode = i18n.language.toLowerCase();
                // Handle language variants (e.g., 'es-ES' → 'es')
                if (langCode.includes('-')) {
                    langCode = langCode.split('-')[0];
                }

                const response = await api.get(`/rules/${langCode}`);
                if (response?.data) {
                    setRules(response.data);
                    setError(null);
                } else {
                    throw new Error(t('failed-to-fetch-rules'));
                }
            } catch (error) {
                console.error('Failed to fetch rules:', error);
                const errorMessage =
                    error.response?.data?.error || error.message || t('failed-to-fetch-rules');
                setError(errorMessage);
                setRules(null);
            } finally {
                setLoading(false);
            }
        };
        fetchRules();
    }, [t, i18n.language]);

    const formatDate = (date) => {
        if (!date) return '';
        return new Date(date).toLocaleDateString(i18n.language, {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    if (loading) {
        return (
            <div className="view-model rules-view">
                <div className="rules-content">
                    <p>{t('loading')}...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="view-model rules-view">
                <div className="rules-content">
                    <p className="error-message">{error}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="view-model rules-view">
            <div className="rules-content markdown-content">
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                    {rules?.text || `# ${t('rules')}\n\n${t('no-rules-available')}`}
                </ReactMarkdown>
            </div>

            {rules?.updatedAt && (
                <div className="rules-footer">
                    <p className="last-updated">
                        {t('last-updated')}: {formatDate(rules.updatedAt)}
                    </p>
                </div>
            )}
        </div>
    );
}